const showToast = (text, background = 'red', duration = 3000) => {
  if (typeof Toastify === 'function') {
    Toastify({
      close: true,
      text,
      duration,
      newWindow: true,
      gravity: 'top',
      position: 'center',
      style: {
        background,
        color: 'white'
      },
    }).showToast();
  } else {
    alert(text);
  }
};
